module.exports = __webpack_public_path__ + "static/media/whyus_atencion.8c05c2d6.jpg";